












































import Vue from "vue";
import { Component, Inject } from "vue-property-decorator";
import {
  MUSIC_NATURE_SOUND_CREATE,
  MUSIC_NATURE_SOUND_EDIT,
} from "@/route-names";
import EventBus from "@models/eventBus";
import BackgroundFilesGetListResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/BackgroundFilesService/BackgroundFilesGetListResponse";
import { DragLiModel } from "@components/ui/models";
import FilterRequest from "@/api/dataSource/api/Spirit/Common/Extensions/Models/FilterRequest";
import TranslationItemModel from "@models/translationItemModel";
import ChangeSortIndexNewRequest from "@/api/dataSource/api/Spirit/Common/Helpers/Models/ChangeSortIndexNewRequest";
import SortIndexNewRequest from "@/api/dataSource/api/Spirit/Common/Helpers/Models/SortIndexNewRequest";

@Component
export default class PageNatureSoundComponent extends Vue {
  @Inject("eventBus") eventBus: EventBus;
  columnNames = ["#", "Картинка", "Название", "Платная", "", ""];
  createRouteName = MUSIC_NATURE_SOUND_CREATE;
  editRouteName = MUSIC_NATURE_SOUND_EDIT;
  getDataFunc = this.$api.BackgroundFileService.getListAsync.bind(
    this.$api.BackgroundFileService
  );
  removeFunc = this.$api.BackgroundFileService.deleteAsync.bind(
    this.$api.BackgroundFileService
  );
  async created() {}
  async startDelete(item: BackgroundFilesGetListResponse) {
    this.eventBus.deleteEntity.trigger({ id: item.Id });
  }

  /**
   * * Получить список для изменения порядка
   */
  async getList() {
    let self = this;
    return new Promise<Array<DragLiModel>>(async (resolve) => {
      await self.$api.BackgroundFileService.getListAsync(
        new FilterRequest()
      ).then((response) => {
        if (response.Items) {
          return resolve(
            response.Items.map(
              (x, index) =>
                new DragLiModel({
                  Id: x.Id,
                  SortIndex: index + 1,
                  Image: x.CoverImageUrl,
                  Translate: x.Translations.map(
                    (t) =>
                      new TranslationItemModel({
                        langCode: t.LangCode,
                        name: t.Name,
                      })
                  ),
                })
            )
          );
        } else {
          return resolve(null);
        }
      });
    });
  }

  /**
   * * Изменить порядковый индекс
   * @param items Список с измененными индексами
   */
  async changeSortIndex(items: Array<DragLiModel>) {
    let self = this;
    return new Promise<boolean>(async (resolve) => {
      await self.$api.BackgroundFileService.changeSortIndexAsync(
        new ChangeSortIndexNewRequest({
          SortIndices: items.map(
            (x) =>
              new SortIndexNewRequest({
                Id: x.Id + "",
                SortIndex: x.SortIndex,
              })
          ),
        })
      ).then((result) => {
        if (result) {
          this.$notification.success("Порядок успешно изменен.");
        }
        return resolve(true);
      });
    });
  }
}
